import { useMemo } from "react"

import { useSessionTypeStatsQuery } from "@/hooks/api/useSessionQuery"

import "./sessionDistributionWidget.scss"

export default function SessionDistributionWidget() {
  const { data: sessionTypeStats } = useSessionTypeStatsQuery()

  const series = useMemo(() => {
    if (!sessionTypeStats) return []

    return sessionTypeStats
      .filter((s) => s.name !== "null")
      .map((s) => ({ name: s.name, count: s.count }))
      .sort((a, b) => b.count - a.count)
  }, [sessionTypeStats])

  const total = useMemo(() => series.reduce((sum, item) => sum + item.count, 0), [series])

  const formatPercent = (count: number) =>
    total === 0 ? "0.0%" : `${((count / total) * 100).toFixed(1)}%`

  return (
    <ul className="SessionDistributionWidget">
      {series.map((item) => {
        const ratio = total > 0 ? (item.count / total) * 100 : 0
        return (
          <li key={item.name} className="SessionDistributionWidget__item">
            <div className="SessionDistributionWidget__row">
              <span className="SessionDistributionWidget__name">{item.name}</span>
              <span className="SessionDistributionWidget__count">{item.count}</span>
              <span className="SessionDistributionWidget__percent">
                {formatPercent(item.count)}
              </span>
            </div>
            <div className="SessionDistributionWidget__track">
              <div className="SessionDistributionWidget__fill" style={{ width: `${ratio}%` }} />
            </div>
          </li>
        )
      })}
    </ul>
  )
}
